import MuiInputLabel from '@mui/material/InputLabel';

import { styled } from 'helpers';

import { InputLabelProps } from './InputLabel.types';

// prettier-ignore
export const InputLabel = styled(MuiInputLabel, {shouldForwardProp: (prop) => prop !== 'hiddenLabel' })<InputLabelProps>`
  color: ${({ theme }) => theme.palette.blueGrey['A600']};
  display: block;
  position: static;
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.typography.pxToRem(10)};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  line-height: 14px;
  letter-spacing: 0.3px;
  pointer-events: auto; // for some reason MUI defaults the value to 'none', which breaks the browser's ability to focus the input
  transform: none;
  padding-bottom: 8px;

  &.Mui-focused {
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
  }
  
  &.Mui-error:not(.Mui-disabled) {
    color: ${({ theme }) => theme.palette.deepOrange['900']};
  }

  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
    
    & .MuiInputLabel-asterisk, 
    & .MuiFormLabel-asterisk {
      color: ${({ theme }) => theme.palette.blueGrey['A600']};
    }
  }
`;
InputLabel.displayName = 'InputLabel';
